<div class="container-fluid mt-3 mb-3 theme">
    <div class="row nowrap mt-4 mb-3" aria-label="breadcrumb">
        <div class="col-lg-10">
            <div class="d-flex usercontrol">
                <h1>ODI</h1>
                <ul class="breadcrumbcustom" role="navigation" aria-labelledby="breadcrumb">
                    <li><a routerLink="">Home</a></li>
                    <li><a routerLink="/securities">Securities</a></li>
                    <li><a routerLink="/securities/odi" skipLocationChange>ODI</a></li>
                    <li><a class="active" routerLink="/securities/odi/uploadAnnexure" skipLocationChange
                            aria-current="page">Upload Annexure</a></li>
                </ul>
            </div>
        </div>
    </div>
    <!-- <div class="card card-body" *ngIf="this.submittedPNotesID == 'newRequest'">
        <form [formGroup]='pNoteForm' (ngSubmit)="uploadAnnexure()">
            <div class="row ml-2 ">
                <div class="col-lg-3 form-group">
                    <div class="">
                        <p>Download Sample Document</p>
                        <i class="fa fa-download" style="font-size: 25px;" aria-hidden="true"
                            (click)="downloadSampleAnnexure()"></i>
                    </div>
                </div>
                <div *ngIf="this.submittedPNotesID == 'newRequest'" class="col-lg-3 form-group">
                    <label>Upload Annexure(XLSX File)<span class="red">*</span> </label>
                    <input id="upload_file1" type="file" class="form-control" formControlName="annexureFile" #file
                        (change)="onChange($event)" placeholder="Select A File">
                    <p *ngIf="f.annexureFile.invalid && f.annexureFile.touched" class="error nocase">
                        Please upload file
                    </p>
                    <p *ngIf="xlsxFileError" class="error nocase">
                        Please upload xlsx file
                    </p>
                    <div *ngIf="fileName">
                        <label>Attached file</label>
                        <p>{{fileName}}
                            <span class="ml-2">
                                <svg (click)="removeFile('xlsx')" xmlns="http://www.w3.org/2000/svg" width="15"
                                    height="15" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 15 15">
                                    <path
                                        d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
                                </svg>
                            </span>
                        </p>
                    </div>
                </div>
                <div class="col-lg-1 form-group mt-2"></div>
                <div class="col-lg-1 form-group mt-4">
                    <button class="btn btn-primary full-width"
                        [disabled]="pNoteForm.invalid || xlsxFileError">Upload</button>
                </div>
                <div class="col-lg-1 form-group mt-4">
                    <button class="btn btn-secondary full-width" (click)="back()">Back</button>
                </div>
            </div>
        </form>
    </div> -->
    <div class="card card-body" *ngIf="this.submittedPNotesID == 'newRequest'">
        <form [formGroup]='pNoteForm' (ngSubmit)="uploadAnnexure()">
            <div class="row">
                <div class="col-lg-4 col-sm-4">
                    <label>Upload Annexure (XLSX File)</label>
                    <input id="upload_file1" type="file" class="form-control" formControlName="annexureFile" #file
                        (change)="onChange($event)" placeholder="Select A File">
                    <p *ngIf="f.annexureFile.invalid && f.annexureFile.touched && !xlsxFileError" class="error nocase">
                        Please upload file
                    </p>
                    <p *ngIf="xlsxFileError" class="error nocase">
                        Please upload xlsx file
                    </p>
                </div>
                <div *ngIf="fileName" class="col-lg-4 col-sm-4">
                    <label>Attached file</label>
                    <p>{{fileName}}
                        <span class="ml-2">
                            <svg (click)="removeFile()" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                <path
                                    d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
                            </svg>
                        </span>
                    </p>
                </div>
                <div class="col-lg-4 col-sm-4">
                    <button class="btn btn-link" (click)="downloadSampleAnnexure()" type="button">Download Sample
                        File</button>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-lg-2 col-md-3 col-sm-4 col-6 form-group">
                    <button class="btn btn-primary full-width"
                        [disabled]="pNoteForm.invalid || xlsxFileError">Upload</button>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-4 col-6 form-group">
                    <button class="btn btn-secondary full-width" (click)="back()">Back</button>
                </div>
            </div>
        </form>
    </div>
    <div *ngIf="isValidFileUploaded && submittedPNotesID != 'newRequest'" class="card card-body">
        <ul class="nav nav-pills row-cols-3 row-cols-sm-3 row-cols-lg-5">
            <li class="nav-item col">
                <a class="nav-link active" id="annexA" data-toggle="tab" href="#annexureATab"
                    data-target="#annexureATab" aria-controls="annexureATab" aria-selected="true">Annexure A</a>
            </li>
            <li class="nav-item col">
                <a class="nav-link" id="annexB" data-toggle="tab" href="#annexureBTab" data-target="#annexureBTab"
                    aria-controls="annexureBTab" aria-selected="true">Annexure B</a>
            </li>
            <li class="nav-item col">
                <a class="nav-link" id="annexC" data-toggle="tab" href="#annexureCTab" data-target="#annexureCTab"
                    aria-controls="annexureCTab" aria-selected="true">Annexure C</a>
            </li>
            <li class="nav-item col">
                <a class="nav-link" id="annexD" data-toggle="tab" href="#annexureDTab" data-target="#annexureDTab"
                    aria-controls="annexureDTab" aria-selected="true">Annexure D</a>
            </li>
            <li class="nav-item col">
                <a class="nav-link" id="annexE" data-toggle="tab" href="#annexureETab" data-target="#annexureETab"
                    aria-controls="annexureETab" aria-selected="true">Annexure E</a>
            </li>
        </ul>
        <div class="tab-content">
            <div class="tab-pane fade show active" id="annexureATab" aria-labelledby="annexA">
                <div class="card card-body">
                    <!-- *ngIf="submitted" -->
                    <h4 class="mt-2">OFFSHORE DERIVATIVE INSTRUMENTS FOR {{previousMonth}} {{year}}</h4>
                    <div class="table-responsive scrollable mt-2">
                        <table id="annexureA" class="table common-table table-bordered table-light" datatable
                            [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th colspan="2" class="text-center">Issuer Details</th>
                                    <th colspan="5" class="text-center">Information on ODI</th>
                                    <th colspan="7" class="text-center">Information on the subscriber/holder/last
                                        holder of the ODI</th>
                                    <th colspan="19" class="text-center">Information on ODI and hedge in India</th>
                                </tr>
                                <tr>
                                    <th rowspan="2">Flag</th>
                                    <th rowspan="2">Sr. No.</th>
                                    <th rowspan="2">Name of Issuer FPI</th>
                                    <th rowspan="2">Registration Number of issuer FPI</th>
                                    <th rowspan="2">Reference No./ISIN of the ODI 1 & 2</th>
                                    <th rowspan="2">Whether the ODI is listed on Stock Exchange Yes or No</th>
                                    <th rowspan="2">If yes Name of the stock Exchange</th>
                                    <th rowspan="2">Maturity date of the ODI</th>
                                    <th rowspan="2">Reference ISIN No. of Indian Underlying</th>
                                    <th rowspan="2">Name of the ODI subscriber</th>
                                    <th rowspan="2">Whether ODI subscriber is a grandfathered subscriber</th>
                                    <th rowspan="2">In case ODI subscriber is a FPI, then Registration No. of the
                                        FPI</th>
                                    <th rowspan="2">Legal Entity Identifier (LEI) number of the ODI subscriber</th>
                                    <th rowspan="2">Location of the ODI subscriber</th>
                                    <th rowspan="2">Type of the ODI subscriber</th>
                                    <th rowspan="2">Regulator Name and Jurisdiction</th>
                                    <!-- <th rowspan="2">Type of the ODI subscriber (e.g. hedge funds , mutual fund,
                                            insurance, pension fund, trust etc) </th> -->
                                    <!-- <th rowspan="2">Name and jurisdiction of the Regulator with whom the ODI
                                            subscriber, is regulated in terms of Regulation 22 of SEBI (FPI)
                                            Regulations, 2014</th> -->
                                    <th rowspan="2">Transaction Date for the Offshore Derivative Instrument</th>
                                    <th rowspan="2">Type of Offshore Derivative Instrument</th>
                                    <th rowspan="2">ISIN Number/other avilable code of the hedged securities in
                                        India</th>
                                    <th rowspan="2">Type of hedge Instrument3</th>
                                    <th colspan="3" class="text-center">Opening Balance</th>
                                    <th colspan="3" class="text-center">Issued</th>
                                    <th colspan="3" class="text-center">Renewed</th>
                                    <th colspan="3" class="text-center">Redeemed/Expired/Cancelled</th>
                                    <th colspan="3" class="text-center">Outstanding</th>
                                </tr>
                                <tr>
                                    <th class="text-center">Opening Balance quantity</th>
                                    <th class="text-center">Opening Balance USD</th>
                                    <th class="text-center">Opening Balance INR</th>

                                    <th class="text-center">Issued quantity</th>
                                    <th class="text-center">Issued USD</th>
                                    <th class="text-center">Issued INR</th>

                                    <th class="text-center">Renewed quantity</th>
                                    <th class="text-center">Renewed USD</th>
                                    <th class="text-center">Renewed INR</th>

                                    <th class="text-center">Redeemed/Expired/Cancelled quantity</th>
                                    <th class="text-center">Redeemed/Expired/Cancelled USD</th>
                                    <th class="text-center">Redeemed/Expired/Cancelled INR</th>

                                    <th class="text-center">Outstanding quantity</th>
                                    <th class="text-center">Outstanding USD</th>
                                    <th class="text-center">Outstanding INR</th>
                                </tr>
                                <tr class="column-search">
                                    <th></th>
                                    <th></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of annxAList; let i = index">
                                    <td>{{data.issuerDtlsFlg}}</td>
                                    <td>{{data.issuerDtlsSrNo}}</td>
                                    <td>{{data.issuerFpi}}</td>
                                    <td>{{data.issuerFpiRegNo}}</td>
                                    <td>{{data.odiRefOrIsin}}</td>
                                    <td>{{data.odiIsListed}}</td>
                                    <td>{{data.odiStockExchg}}</td>
                                    <td>{{this.datePipe.transform(data.odiMatDate, 'dd-MMM-yyyy')}}</td>
                                    <td>{{data.odiRefOrIsinIndian}}</td>
                                    <td>{{data.subOdiName}}</td>
                                    <td>{{data.subIsGrandFather}}</td>
                                    <td>{{data.subFpiRegno}}</td>
                                    <td>{{data.subLeiCode}}</td>
                                    <td>{{data.subOdiLoc}}</td>
                                    <td>{{data.subOdiType}}</td>
                                    <td>{{data.subRgltrNamejrsdctn}}</td>
                                    <td>{{this.datePipe.transform(data.odiHdgeTxnDate, 'dd-MMM-yyyy')}}</td>
                                    <td>{{data.odiHdgeType}}</td>
                                    <td>{{data.odiHdgeIsinNoCode}}</td>
                                    <td>{{data.odiHdgeIstType}}</td>
                                    <td>{{data.odiHdgeOpnBlnceQty}}</td>
                                    <td>{{data.odiHdgeOpnBlnceUsd}}</td>
                                    <td>{{data.odiHdgeOpnBlnceInr}}</td>
                                    <td>{{data.odiHdgeIssuedQty}}</td>
                                    <td>{{data.odiHdgeIssuedUsd}}</td>
                                    <td>{{data.odiHdgeIssuedInr}}</td>
                                    <td>{{data.odiHdgeRenewedQty}}</td>
                                    <td>{{data.odiHdgeRenewedUsd}}</td>
                                    <td>{{data.odiHdgeRenewedInr}}</td>
                                    <td>{{data.odiHdgeRdmExpCncQty}}</td>
                                    <td>{{data.odiHdgeRdmExpCncUsd}}</td>
                                    <td>{{data.odiHdgeRdmExpCncInr}}</td>
                                    <td>{{data.odiHdgeOutstndQty}}</td>
                                    <td>{{data.odiHdgeOutstndUsd}}</td>
                                    <td>{{data.odiHdgeOutstndInr}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade show" id="annexureBTab" aria-labelledby="annexB">
                <div class="card card-body">
                    <h4 class="mt-2">Details of trades in securities for hedging of ODIs in India for
                        {{previousMonth}} {{year}}</h4>
                    <ul class="nav nav-pills">
                        <li class="nav-item col-lg-3 col-md-4 col-sm-6 col-6"
                            *ngFor="let data of instrumentSet;let i=index">
                            <a class="nav-link" [ngClass]="i==0?'active':''" id="annexBInst{{data}}" data-toggle="tab"
                                href="#annexBInstTab" data-target="#annexBInstTab" aria-controls="annexBInstTab"
                                aria-selected="true" (click)="onChangeAnnxInst(data, 'Annexure B')">{{data}}</a>
                        </li>
                    </ul>
                    <!-- <div class="col-lg-2 form-group ">
                            <label>Financial Instrument<span class="red">*</span> </label>
                            <select class="form-control form-control-sm" title="Select Instrument Type"
                                (change)="onChangeAnnxInst($event, 'Annexure B')">
                                <option *ngFor="let data of instrumentSet" value="{{data}}">{{data}}
                                </option>
                            </select>
                        </div> -->
                    <div class="tab-pane fade show" id="annexBInstTab" aria-labelledby="annexBInst">
                        <div class="card card-body">
                            <div [ngClass]="{'hidden':derivativeBFlag,'visible':!derivativeBFlag}"
                                class="table-responsive scrollable mt-2">
                                <table id="annexureB" class="table common-table table-bordered" datatable
                                    [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Date Of Transaction</th>
                                            <th>Name of the Indian Company</th>
                                            <th>ISIN of the Indian Security</th>
                                            <th>Quantity</th>
                                            <th>Value</th>

                                        </tr>
                                        <tr class="column-search">
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let data of annxBListCurrent; let i = index">
                                            <td>{{data.anxrDtlsSrno}}</td>
                                            <td>{{this.datePipe.transform(data.anxrDtlsTxndt, 'dd-MMM-yyyy')}}</td>
                                            <td>{{data.anxrDtlsCmpnynameNm}}</td>
                                            <td>{{data.anxrDtlsIsin}}</td>
                                            <td>{{data.anxrDtlsQty}}</td>
                                            <td>{{data.anxrDtlsVl}}</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                            <div [ngClass]="{'hidden':!derivativeBFlag,'visible':derivativeBFlag}"
                                class="table-responsive scrollable mt-2">
                                <table id="annexureBDerivative" class="table common-table table-bordered" datatable
                                    [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Date Of Transaction</th>
                                            <th>Name of Underlying - Name of Indian
                                                Company</th>
                                            <th>Reference ISIN/ available Code of the
                                                Indian Security</th>
                                            <th>Expiry date</th>
                                            <th>Position</th>
                                        </tr>
                                        <tr class="column-search">
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let data of annxBListCurrent; let i = index">
                                            <td>{{data.anxrDtlsSrno}}</td>
                                            <td>{{this.datePipe.transform(data.anxrDtlsTxndt, 'dd-MMM-yyyy')}}</td>
                                            <td>{{data.anxrDtlsCmpnynameNm}}</td>
                                            <td>{{data.anxrDtlsIsin}}</td>
                                            <td>{{this.datePipe.transform(data.anxrDtlsExpDt, 'dd-MMM-yyyy')}}</td>
                                            <td>{{data.anxrDtlsQty}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade show" id="annexureCTab" aria-labelledby="annexC">
                <div class="card card-body">
                    <h4 class="mt-2">Details of Assets under management of securities held in India as on
                        {{lastDateofPreviousMonth}} {{previousMonth}}, {{year}} </h4>
                    <ul class="nav nav-pills">
                        <li class="nav-item col-lg-3 col-md-4 col-sm-6 col-6"
                            *ngFor="let data of instrumentSet;let i=index">
                            <a class="nav-link" [ngClass]="i==0?'active':''" id="annexCInst{{data}}" data-toggle="tab"
                                href="#annexCInstTab" data-target="#annexCInstTab" aria-controls="annexCInstTab"
                                aria-selected="true" (click)="onChangeAnnxInst(data, 'Annexure C')">{{data}}</a>
                        </li>
                    </ul>
                    <!-- <div class="col-lg-2 form-group ">
                            <label>Financial Instrument<span class="red">*</span> </label>
                            <select class="form-control form-control-sm" title="Select Instrument Type"
                                (change)="onChangeAnnxInst($event, 'Annexure C')">
                                <option *ngFor="let data of instrumentSet" value="{{data}}">{{data}}
                                </option>
                            </select>
                        </div> -->
                    <div class="tab-pane fade show" id="annexCInstTab" aria-labelledby="annexCInst">
                        <div class="card card-body">
                            <div [ngClass]="{'hidden':derivativeCFlag,'visible':!derivativeCFlag}"
                                class="table-responsive scrollable mt-2">
                                <table id="annexureC" class="table common-table table-bordered" datatable
                                    [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Name of the Indian Company</th>
                                            <th>ISIN of the Indian Security</th>
                                            <th>Quantity</th>
                                            <th>Value</th>
                                        </tr>
                                        <tr class="column-search">
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let data of annxCListCurrent; let i = index">
                                            <td>{{data.anxrDtlsSrno}}</td>
                                            <td>{{data.anxrDtlsCmpnynameNm}}</td>
                                            <td>{{data.anxrDtlsIsin}}</td>
                                            <td>{{data.anxrDtlsQty}}</td>
                                            <td>{{data.anxrDtlsVl}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div [ngClass]="{'hidden':!derivativeCFlag,'visible':derivativeCFlag}"
                                class="table-responsive scrollable mt-2">
                                <table id="annexureCDerivative" class="table common-table table-bordered" datatable
                                    [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Instrument Type</th>
                                            <th>Name of Underlying - Name of Indian
                                                Company</th>
                                            <th>Reference ISIN/ available Code of the
                                                Indian Security</th>
                                            <th>Expiry date</th>
                                            <th>Position</th>
                                        </tr>
                                        <tr class="column-search">
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                            <th><input type="text" class="form-control form-control-sm" /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let data of annxCListCurrent; let i = index">
                                            <td>{{data.anxrDtlsSrno}}</td>
                                            <td>{{data.anxrDtlsInstType}}</td>
                                            <td>{{data.anxrDtlsCmpnynameNm}}</td>
                                            <td>{{data.anxrDtlsIsin}}</td>
                                            <td>{{this.datePipe.transform(data.anxrDtlsExpDt, 'dd-MMM-yyyy')}}</td>
                                            <td>{{data.anxrDtlsQty}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade show" id="annexureDTab" aria-labelledby="annexD">
                <div class="card card-body">
                    <!-- *ngIf="submitted" -->
                    <h4 class="mt-2">Statement on information regarding Beneficial owner</h4>
                    <div class="table-responsive scrollable mt-2">
                        <table id="annexureD" class="table common-table table-bordered table-light" datatable
                            [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                            <thead>
                                <tr>
                                    <th rowspan="2" class="text-center">Name of ODI subscriber of the ODI as per
                                        annexure A (1)</th>
                                    <th colspan="3" class="text-center">Details of beneficial owner (2)</th>
                                    <th colspan="3" class="text-center">Details of Investment manager controlling
                                        the investment activity of ODI subscriber (3)</th>
                                    <th colspan="3" class="text-center">In case no BO identified holding over
                                        threshold (15% or 25% as applicable) or on basis of control in the ODI
                                        subscriber, details of natural person who holds the position of the senior
                                        managing officials in ODI subscriber or Investment manager (if controlling
                                        the affairs) of the ODI subscriber. (This column is applicale only when no
                                        details are disclosable under column 2) (4)</th>
                                </tr>
                                <tr>
                                    <th class="text-center">Name & address of such beneficial owner </th>
                                    <th class="text-center">Nationality of such beneficial owner </th>
                                    <th class="text-center">% holding in the ODI subscriber or control basis</th>

                                    <th class="text-center">Name of the Investment manager (legal entity name)</th>
                                    <th class="text-center">Jurisdiction of the Investment manager</th>
                                    <th class="text-center">Whether regulated as Investment manager by regulator in
                                        FATF member country </th>
                                    <th class="text-center">Name & designation of the senior managing official(s)
                                        (SMO)</th>
                                    <th class="text-center">Whether SMO is of ODI subscriber or Investment manager
                                    </th>
                                    <th class="text-center">Nationality</th>
                                </tr>
                                <tr class="column-search">
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of annxDList; let i = index">
                                    <td>{{data.odiSubName}}</td>
                                    <td>{{data.benfcalOwnerNameAddr}}</td>
                                    <td>{{data.benfcalOwnernationality}}</td>
                                    <td>{{data.subOdiHoldingPrcnt}}</td>
                                    <td>{{data.invstMngrName}}</td>
                                    <td>{{data.jrsdctnInvstMngr}}</td>
                                    <td>{{data.regultaedInvstMngr}}</td>
                                    <td>{{data.nameDesgntnMngr}}</td>
                                    <td>{{data.smoIsOdiSubInvstMngr}}</td>
                                    <td>{{data.nationality}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade show" id="annexureETab" aria-labelledby="annexE">
                <div class="card card-body">
                    <!-- *ngIf="submitted" -->
                    <h4 class="mt-2">Reconciliation / Reconfirmation Report</h4>
                    <div class="table-responsive scrollable mt-2">
                        <table id="annexureE" class="table common-table table-bordered table-light" datatable
                            [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                            <thead>
                                <tr>
                                    <th colspan="2" class="text-center">Reference</th>
                                    <th colspan="4" class="text-center">Details of Original ODI subscriber</th>
                                    <th colspan="4" class="text-center">Details of entity to whom the ODI is
                                        transferred</th>
                                    <th colspan="7" class="text-center">Details of transfer</th>
                                </tr>
                                <tr>
                                    <th>Row No. as per Annexure A</th>
                                    <th>Sr. No as per Annexure A</th>

                                    <th>Name</th>
                                    <th>Type</th>
                                    <th>Location</th>
                                    <th>Jurisdiction</th>

                                    <th>Name</th>
                                    <th>Type</th>
                                    <th>Location</th>
                                    <th>Jurisdiction</th>

                                    <th>Whether prior consent taken</th>
                                    <th>If yes Date of the prior consent</th>
                                    <th>date of transfer</th>
                                    <th>date of Reconciliation</th>
                                    <th>Qty transferred</th>
                                    <th>Market value of ODI (US $) as on date of transfer</th>
                                    <th>Market value of ODI (Rs) as on date of transfer</th>
                                </tr>
                                <tr class="column-search">
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of annxEList; let i = index">
                                    <!-- <td (click)="open(data.anxrId)" class="refNo pointer ">
                                    {{data.anxrId}}
                                </td> -->
                                    <td>{{data.anxrARow}}</td>
                                    <td>{{data.anxrASrNo}}</td>
                                    <td>{{data.odiSubName}}</td>
                                    <td>{{data.odiSubTYPE}}</td>
                                    <td>{{data.odiLocation}}</td>
                                    <td>{{data.odiJurisdiction}}</td>
                                    <td>{{data.enitiySubName}}</td>
                                    <td>{{data.entitySubTYPE}}</td>
                                    <td>{{data.entityLocation}}</td>
                                    <td>{{data.entityJurisdiction}}</td>
                                    <td>{{data.dtlsTnsfrPriorConsent}}</td>
                                    <td>{{this.datePipe.transform(data.dtlsTnsfrPriorConstDate, 'dd-MMM-yyyy')}}
                                    </td>
                                    <td>{{this.datePipe.transform(data.dtlsTnsfrDate, 'dd-MMM-yyyy')}}</td>
                                    <td>{{this.datePipe.transform(data.dtlsRecncltnDate, 'dd-MMM-yyyy')}}</td>
                                    <td>{{data.dtlsTrnsfrQty}}</td>
                                    <td>{{data.mktValOdiUs}}</td>
                                    <td>{{data.mktValOdiInr}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!showApproveReject || entityType != 'MEMBER'" class="row">
            <div class="col-lg-11 form-group"></div>
            <!-- <div class="col-lg-1 form-group mt-2">
                    <button class="btn btn-primary full-width" (click)="confirmPNoteAnnexureByMaker()">Submit</button>
                </div> -->
            <div class="col-lg-1 form-group mt-2">
                <button class="btn btn-secondary full-width" (click)="back()">Back</button>
            </div>
        </div>
        <div *ngIf="showApproveReject &&  entityType == 'MEMBER'" class="row">
            <div class="col-lg-6 form-group">
                <span>
                    <label>Checker Comments</label>
                    <textarea class="form-control" contenteditable formControlName="comment" id="comment"></textarea>
                </span>
            </div>
            <div class="justify-content-end col-lg-6">
                <div class="row mt-4">
                    <div class="col-lg-6"></div>
                    <div class="col-lg-2 mt-4">
                        <button class="btn full-width approveButton" data-toggle="modal"
                            data-target="#approveModal">Approve</button>
                    </div>
                    <div class="col-lg-2 mt-4">
                        <button class="btn full-width rejectButton" data-toggle="modal"
                            data-target="#rejectModal">Reject</button>
                    </div>
                    <div class="col-lg-2 form-group mt-4">
                        <button class="btn btn-secondary full-width" (click)="back()">Back</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!isValidFileUploaded">
        <h4 class="mt-2">Errors in the file uploaded above</h4>
        <div class="table-responsive scrollable card card-body mt-2 mb-2">
            <table id="errorTable" class="table common-table table-bordered table-light" datatable
                [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th>Annexure type</th>
                        <th>Cell Number</th>
                        <th>Cell Data</th>
                        <th>Error</th>
                    </tr>
                    <tr class="column-search">
                        <th></th>
                        <th>
                            <select class="form-control form-control-sm" title="Select Annexure Type">
                                <option value=".*">Select Annexure Type</option>
                                <option *ngFor="let data of annexureSet" value="{{'.*'+data+'.*'}}">{{data}}
                                </option>
                            </select>
                        </th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let errorData of annxErrorList; let i = index">
                        <td>{{i+1}}</td>
                        <td>{{errorData.annexureType}}</td>
                        <td>{{errorData.cellPosition}}</td>
                        <td>{{errorData.cellData}}</td>
                        <td>{{errorData.cellError}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="modal fade" id="approveModal" tabindex="-1" role="dialog" aria-labelledby="approveModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <button type="button" class="close d-flex justify-content-end mr-2" data-dismiss="modal"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="modal-body text-center">
                    <h6>Are you sure you want to approve this submission?</h6>
                    <div class="d-flex justify-content-center mt-3">
                        <div class="col-3"><button type="button" class="btn btn-primary full-width"
                                data-dismiss="modal">No</button></div>
                        <div class="col-3"><button type="button" class="btn btn-secondary full-width"
                                data-dismiss="modal" (click)="confirmPNoteAnnexureByChecker('APPROVED')">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="rejectModal" tabindex="-1" role="dialog" aria-labelledby="rejectModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <button type="button" class="close d-flex justify-content-end mr-2" data-dismiss="modal"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="modal-body text-center">
                    <h6>Are you sure you want to reject this submission?</h6>
                    <div class="d-flex justify-content-center mt-3">
                        <div class="col-3"><button type="button" class="btn btn-primary full-width"
                                data-dismiss="modal">No</button></div>
                        <div class="col-3"><button type="button" class="btn btn-secondary full-width"
                                data-dismiss="modal" (click)="confirmPNoteAnnexureByChecker('REJECTED')">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>